import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

const LeftArrow = ({ stroke = '#4E4C55' }: { stroke?: string }) => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 13L1 7L7 1"
                    stroke={stroke}
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 18L2 10L10 2"
                    stroke={stroke}
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.75 0.75L1.25 5L5.75 9.25"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default LeftArrow;
